import React from 'react';

import Button from '@components/uikit/Button/Button';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  icon: React.ReactElement;
  name: string;
  url: string;
}

const ProductGuideItem: React.FC<IProps> = ({ icon, name, url }) => {
  const { t } = useTranslation();

  return (
    <div className={style.productGuide}>
      <div className={style.guideInfo}>
        {icon}
        <div className={style.guideName}>{t(name)}</div>
      </div>
      <Button type="secondary" onClick={() => window.open(url, '_blank')} text={t('Open')} />
    </div>
  );
};

export default ProductGuideItem;
